import type React from "react";

import { hasCrmPermissions } from "app/components/SideBar/utils";
import { MANAGEMENT_ROUTE } from "app/pages/sales-intelligence/constants/routes";
import { proNavigator } from "single-spa/react-app/ProNavigator";

const withIntegrationAccess = <PROPS extends object>(Component: React.ComponentType<PROPS>) => {
    return function (props: PROPS) {
        const hasCrmAccess = hasCrmPermissions();
        if (!hasCrmAccess) {
            proNavigator.go(MANAGEMENT_ROUTE);
        }

        return <Component {...props} />;
    };
};

export default withIntegrationAccess;
